
(function ($) {
    "use strict";
    $(function () {

        $('.youtube-player').on('click', function () {
            $(this).html(`<iframe src="https://www.youtube.com/embed/${$(this).data('id')}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`);
        });


        $('.js-video-slider').each(function (e) {

            var $that = $(this);
            $that.on('init reInit', function (event, slick) {
                if (slick.slideCount < 2) {
                    $that.parent().find('.arrow-container').hide();
                } else {
                    $that.parent().find('.arrow-container').show();
                }

            });

            $that.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $that.parent().find('.carousel-prev'),
                nextArrow: $that.parent().find('.carousel-next'),
            });
            $($that).on('beforeChange', function (slick, currentSlide, nextSlide) {
                $that.find('.slick-current').find('video').trigger('pause');
                if ($that.find('.slick-current').find('.youtube-player iframe').length) {
                    $that.find('.slick-current').find('.youtube-player iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
                }
            });
        });

        $('.js-video-slider-alt').each(function (e) {

            var $that = $(this);
            $that.on('init reInit', function (event, slick) {
                if (slick.slideCount < 4) {
                    $that.parent().parent().find('.arrow-container').hide();
                } else {
                    $that.parent().parent().find('.arrow-container').show();
                }

            });

            $that.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $that.parent().parent().find('.carousel-prev'),
                nextArrow: $that.parent().parent().find('.carousel-next'),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            $($that).on('beforeChange', function (slick, currentSlide, nextSlide) {
                $that.find('.slick-current').find('video').trigger('pause');
                if ($that.find('.slick-current').find('.youtube-player iframe').length) {
                    $that.find('.slick-current').find('.youtube-player iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
                }
            });
        });

        /*   const yplayers = document.querySelectorAll('.youtube-player-wrapper');
     
          let videoObserver = new IntersectionObserver(entries => {
              $.each(entries, (i, entry) => {
     
                  if (entry.intersectionRatio > 0) {
                      $(entry.target).find('.youtube-player').each(function () {
                          if (!$(this).hasClass('wasPlayed')) {
                              $(this).html(`<iframe src="https://www.youtube.com/embed/${$(this).data('id')}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`);
                              $(this).addClass('wasPlayed');
                          } else {
                              $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                          }
     
                      });
     
                      //videoObserver.unobserve(entry.target);
                  } else {
                      $(entry.target).find('.youtube-player').each(function () {
     
                          if ($(this).find('iframe').length == 1) {
                              $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                          }
                      });
                  }
              });
          });
     
          $.each(yplayers, (i, yplayer) => {
              //videoObserver.observe(yplayer);
          }); */
    });
})(jQuery);
